import React from "react";

export default function AboutUs() {
  return (
    <section className="about-strong" id="about">
     
      {/* CONTENT */}
      <div className="container">
        <div className="intro">
          <p>
            <strong>من نحن</strong> — المؤسسة الدولية للاستدامة والتنمية مؤسسة أهلية
            تعمل على تعزيز الاستدامة في كافة قطاعات المجتمع. نؤمن أن الاستدامة
            تسبق التنمية، وأن أي مشروع ناجح يجب أن يحفظ حقوق الأجيال القادمة.
          </p>
        </div>

        <div className="vm">
          <div className="vm-card">
            <div className="vm-icon">🌍</div>
            <h3>رؤيتنا</h3>
            <p>
              مجتمع مستدام يحقق العدالة الاجتماعية والاقتصادية، يحترم الموارد
              الطبيعية، ويمنح المرأة والشباب فرص المشاركة الحقيقية باستخدام حلول
              مبتكرة وتقنية.
            </p>
          </div>

          <div className="vm-card">
            <div className="vm-icon">💡</div>
            <h3>رسالتنا</h3>
            <p>
              تسخير الطاقات والموارد لتطوير المجتمع عبر برامج تدريبية، شراكات
              محلية ودولية، ومشروعات نموذجية تُطبق مبادئ التنمية المستدامة على
              أرض الواقع.
            </p>
          </div>
        </div>

        <div className="cta-row">
          <a href="/join" className="btn-primary">انضم لمبادراتنا</a>
          <p className="cta-note">أو تواصل معنا لمعرفة فرص الشراكة والدعم</p>
        </div>
      </div>

      <style>{`
        /* عام */
        .about-strong { font-family: "Cairo", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial; direction: rtl; color:#0b2340; }

        /* HERO */
        .hero { position: relative; overflow: visible; }
        .hero-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 30px;
          max-width: 1200px;
          margin: 0 auto;
          padding: 48px 20px;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(0,74,173,0.06), rgba(0,74,173,0.03));
          pointer-events: none;
          z-index: 0;
        }

        .hero-text { flex: 1.1; z-index: 2; min-width: 280px; }
        .hero-text h1 {
          color: #003c9e;
          font-size: 2.2rem;
          margin: 0 0 12px 0;
          font-weight: 800;
        }
        .hero-text .lead {
          color: #1f3a66;
          font-size: 1.05rem;
          line-height: 1.8;
          margin-bottom: 18px;
          max-width: 680px;
          text-align: right;
        }

        .hero-cta { display:flex; gap:12px; align-items:center; flex-wrap:wrap; }
        .btn-primary {
          display:inline-block;
          background: linear-gradient(90deg,#004aad,#0066d6);
          color:#fff;
          padding:10px 18px;
          border-radius:10px;
          text-decoration:none;
          font-weight:700;
          box-shadow: 0 8px 24px rgba(0,74,173,0.18);
        }
        .btn-primary:hover { transform: translateY(-3px); }

        .btn-ghost {
          display:inline-block;
          background: transparent;
          border: 2px solid rgba(0,74,173,0.12);
          color: #004aad;
          padding:8px 14px;
          border-radius:10px;
          text-decoration:none;
          font-weight:600;
        }

        .hero-img-wrap { flex: 0.95; display:flex; justify-content:center; align-items:center; position:relative; z-index:1; min-width:260px; }
        .hero-img {
          width: 100%;
          max-width: 520px;
          border-radius: 18px;
          object-fit: cover;
          box-shadow: 0 18px 40px rgba(0,74,173,0.18);
          transform: translateY(0);
          transition: transform 400ms ease, box-shadow 400ms ease;
        }
        .hero-img:hover { transform: translateY(-6px) scale(1.02); box-shadow: 0 26px 60px rgba(0,74,173,0.22); }

        .img-accent {
          position: absolute;
          right: 8%;
          bottom: -18px;
          width: 140px;
          height: 140px;
          background: radial-gradient(circle at 30% 30%, rgba(0,74,173,0.14), rgba(0,74,173,0.06));
          border-radius: 50%;
          filter: blur(18px);
          z-index:0;
        }

        /* STATS */
        .stats {
          max-width: 1100px;
          margin: 12px auto 30px;
          display:flex;
          gap:20px;
          justify-content:center;
          padding: 0 20px;
        }
        .stat {
          flex: 1;
          background: #fff;
          border-radius: 12px;
          padding: 18px;
          text-align: center;
          box-shadow: 0 8px 30px rgba(3,57,127,0.06);
        }
        .stat .num { font-size: 1.6rem; color:#004aad; font-weight:800; }
        .stat .label { color:#556b86; margin-top:6px; font-size:0.95rem; }

        /* CONTENT */
        .container { max-width: 1100px; margin: 30px auto 80px; padding: 0 20px; display:flex; flex-direction:column; gap:28px; }
        .intro p { margin:0; font-size:1.05rem; color:#24334f; line-height:1.9; text-align:justify; }

        .vm { display:flex; gap:24px; align-items:stretch; justify-content:space-between; flex-wrap:wrap; }
        .vm-card {
          flex: 1;
          min-width: 300px;
          background: linear-gradient(180deg,#ffffff,#f7fbff);
          border-radius: 14px;
          padding: 22px;
          box-shadow: 0 10px 28px rgba(3,57,127,0.06);
          border-right: 6px solid rgba(0,74,173,0.08);
          display:flex;
          flex-direction:column;
          gap:12px;
          text-align: right;
        }
        .vm-icon { font-size:1.8rem; }
        .vm-card h3 { margin:0; color:#003c9e; font-size:1.25rem; font-weight:800; }
        .vm-card p { margin:0; color:#374a63; line-height:1.8; font-size:1rem; }

        .cta-row { display:flex; align-items:center; gap:16px; justify-content:flex-start; margin-top:6px; flex-wrap:wrap; }
        .cta-note { color:#4b6280; font-size:0.95rem; margin:0 12px; }

        /* RESPONSIVE: Mobile */
        @media (max-width: 900px) {
          .hero-inner { flex-direction: column-reverse; align-items:center; padding:28px 20px 40px; gap:18px; }
          .hero-text { text-align:center; }
          .hero-text h1 { font-size:1.7rem; }
          .hero-text .lead { font-size:1rem; max-width:100%; }
          .hero-img { max-width: 420px; }
          .img-accent { right: 50%; transform: translateX(50%); bottom: -12px; width: 120px; height:120px; }
          .stats { flex-direction: column; gap:12px; padding: 0 12px; }
          .stat { display:flex; justify-content:space-between; align-items:center; padding:14px 18px; }
          .stat .num { font-size:1.25rem; }
          .vm { flex-direction: column; gap:18px; }
          .cta-row { justify-content:center; text-align:center; }
        }

        @media (max-width: 480px) {
          .about-strong .hero-text h1 { font-size:1.45rem; }
          .intro p { font-size:1rem; }
          .vm-card { padding:18px; }
          .btn-primary { padding:9px 14px; font-size:0.95rem; }
        }
      `}</style>
    </section>
  );
}
